module.exports = __webpack_public_path__ + "img/source-script.bba458c3.svg";